import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCutomJobTypeList(params) {
  return request({
    url: URL.mdm.basicData.cutomJobType,
    method: 'get',
    params
  })
}

export function saveCutomJobType(data) {
  return request({
    url: URL.mdm.basicData.cutomJobType,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delCutomJobType(uuid) {
  return request({
    url: URL.mdm.basicData.cutomJobType + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
export function activeFunc(data, active) {
  return request({
    url: URL.mdm.basicData.cutomJobTypeActiveUrl,
    method: 'post',
    data,
    params: { active }
  })
}
